import React from "react";
import commonMethod from '../../lib/commonMethod'
import RecipeIcon from '../../assets/img/dashboard/recipe'
import {connect} from "react-redux";
import cookie from 'react-cookies'


class RecipeItem extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            isLoad:false
        }

        this.accessToken = cookie.load('accessToken');

    }

    controlRecipe(sceneId) {
        // 레시피 제어
        // let data = {
        //     'family-id' : this.props.familyId,
        //     'scene-id' : sceneId
        // }
        commonMethod.requestPostWithToken('dashboard/scene/?family-id=' +
            this.props.familyId + '&scene-id='+sceneId,
            this.accessToken, this, res => {
                /* setTimeout(
                    function() {
                        this.props.actionDevice();
                    }
                    .bind(this),2000
                ); */
        });
        this.setState({isLoad:true})

        // 애니메이션을 위한 state 변경
        setTimeout(
            function() {
                this.setState({isLoad:false});
            }
            .bind(this),
            700
        );
    }

    render() {
      
        let item = this.props.item;


        return (
            <li key={item.sceneId} tabIndex={item.sceneId} 
                className={this.state.isLoad ? "active" : ""}
                onClick={()=>this.controlRecipe(item.sceneId)}>
                    <div/>
                    <RecipeIcon/>
                    <h4>{item.name}</h4>
                    <span title={this.props.familyName}>{this.props.familyName}</span>
            </li>
            
        )
    }
}

function mapStateToProps(state) {
    return {
        accessToken: state.hejhome.accessToken, 
    }
}


// dispatch - set
const mapDispatchToProps = dispatch => ({
    setAccessToken: (token) => dispatch({
        type: 'setAccessToken',
        accessToken: token,
    }),
});

RecipeItem = connect(mapStateToProps, mapDispatchToProps)(RecipeItem);


export default RecipeItem;
